import { useEffect, useRef } from 'react';
import { useAuth } from '../../../components/contexts/AuthContext';
import { useSocket } from '../../../components/contexts/SocketContext';
export function useQuarantineNotifications(actions) {
  const { authState } = useAuth();
  const { socket } = useSocket();
  const callback = useRef(actions);
  callback.current = actions;
  const identity = `${authState?.id}:${authState?.token}:${authState?.session_id}`;
  useEffect(() => {
    if (!socket || !authState?.isAuthenticated) return undefined;
    const seen = new Set();
    let current = true;
    const received = payload => {
      const item = payload?.notification;
      if (item?.type !== 'messaging_quarantined' || !item.id || !item.data?.conversation_id || seen.has(item.id)) return;
      seen.add(item.id);
      if (seen.size > 200) seen.delete(seen.values().next().value);
      const key = `quarantine:${item.id}`;
      callback.current.show({ key, message: `Chat quarantined: ${item.data.reasons?.map(reason => reason.label).filter(Boolean).join(', ') || 'Security review'}`, duration: 10,
        onClick: () => { if (current) { callback.current.dismiss(key); callback.current.open(item.data.conversation_id); } } });
    };
    socket.on('notifications:new', received);
    return () => { current = false; socket.off('notifications:new', received); seen.forEach(id => callback.current.dismiss(`quarantine:${id}`)); };
  }, [socket, identity, authState?.isAuthenticated]);
}
